import React from "react";
import { Switch, FormControlLabel } from "@mui/material";
import { classNameBuilder } from "../../utilities";

interface ToggleSwitchProps {
  label?: string;
  name?: string;
  value?: boolean | undefined;
  disabled?: boolean;
  readOnly?: boolean;
  className?: string;
  onChange?: (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => void;
}

export default function ToggleSwitch({
  label,
  name,
  value,
  disabled,
  className,
  onChange,
  readOnly,
}: ToggleSwitchProps) {
  return (
    <FormControlLabel
      control={<Switch name={name} checked={value} onChange={onChange} />}
      label={label}
      labelPlacement="start"
      className={classNameBuilder(
        "h-app-input-field",
        "h-app-switch",
        readOnly ? "readonly" : "",
        className ?? ""
      )}
      disabled={disabled || readOnly}
    />
  );
}
